<template>
  <div id="modal_alert" class="modal fade" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <header>
          <i class="fa fa-exclamation-triangle fa-4x"></i>
          <h3 class="modal-title">{{ title }}</h3>
          <p>{{ description }}</p>
        </header>

        <main :style="{ height: Array.isArray(content) ? '300px' : 'auto' }">
          <p v-if="!Array.isArray(content)" v-html="content" />
          <p v-else v-for="(ctt, index) in content" :key="index" v-html="ctt" />
        </main>

        <footer>
          <button @click="close">Sair</button>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalAlert',
  data() {
    return {
      title: 'titulo',
      description: 'descrição',
      content: 'conteúdo'
    }
  },
  methods: {
    show({ title, description, content }) {
      this.title = title
      this.description = description
      this.content =
        Array.isArray(content) && content.length === 1
          ? content.shift()
          : content

      window.jQuery('#modal_alert').modal('show')
    },
    close() {
      window.jQuery('#modal_alert').modal('hide')
    }
  }
}
</script>

<style scoped>
div.modal-content {
  max-width: 400px;
  margin: 10px auto;
}

header {
  padding: 16px;
  text-align: center;
  color: white;
  background-color: rgb(229, 114, 115);
}

header h4 {
  margin-top: 10px;
}

main {
  overflow-y: auto;
  padding: 16px 16px 0px 16px;
  background-color: white;
}

main::-webkit-scrollbar {
  width: 5px;
}

main::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px #ccc;
  border-radius: 10px;
}

main::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px #777;
}

main p {
  padding: 8px;
}

main > p:hover {
  background-color: #eaeaea;
}

footer {
  display: flex;
  justify-content: center;
  align-items: center;
}

footer button {
  background-color: rgb(242, 2, 2, 0.7);
  color: white;
  width: 200px;
  height: 40px;
  text-transform: uppercase;
  text-align: center;
  border: 0;
  border-radius: 20px;
  transition: background-color 0.5s;
}

footer button:hover {
  background-color: rgb(242, 2, 2, 0.9);
}
</style>


// WEBPACK FOOTER //
// src/components/common/ModalAlert.vue